import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { FaPen } from "react-icons/fa";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import { Link, useParams } from "react-router-dom";
import GallaryBox from "../../../Components/Global/GallaryBox";
import Loader from "../../../Components/Global/Loader";
import DashboardLayouts from "../../../Components/Layout/DashboardLayouts";
import { useAuth } from "../../../Context/AuthContext";
import useAuthentication from "../../../hooks/useAuthentication";
import useAxiosFetch from "../../../hooks/useAxiosFetch";
import useMultipleImgUpload from "../../../hooks/useMultipleImgUpload";
import useSearchListPagination from "../../../hooks/useSearchListPagination";

function TaskDetails({ allowedRoles }) {
  const { allowLoading } = useAuthentication(allowedRoles);
    // api api from global hook 

  const { axiosFetch} = useAxiosFetch();;
  const { designation, userDetails } = useAuth();
const [isEditableItem, setIsEditable]=useState(true)


  const [requestData, setRequestData] = useState({
    building_name: "",
    deadline: "",
    priority: "",
    status: "",
    task_category: "",
    task_description: "",
    task_image: [],
    default_image: "",
    task_title: "",
    unit_name: "",
    Worker: {},
    worker_roles: "",
    worker_id: "",
    
    isRequest: "",
    created_by: "",

  });
  const {
    onSelectFile,
    deleteHandler,
    uploadToserver,
    selectedImages,
    setSelectedImages,
    defaultImg,
    setdefaultImg,
    handleDefaultImage,
    ImgLinks,
    setImgLinks,
  } = useMultipleImgUpload();
  const {
    building_name,
    deadline,
    priority,
    status,
    task_category,
    unit_name,
    task_title,
    task_image,
    default_image,
    task_description,
    Worker,
    worker_roles ,
   
  
  } = requestData;

  let ID = useParams();
  const taskss_id = ID?.id;

  useEffect(() => {
    if (taskss_id) {
      const url = `/task/show/${taskss_id}`;
      axiosFetch({
        axiosInstance: axios,
        method: "GET",
        url: url,
      })
        .then((response) => {

         
          if (response.data) {
            setRequestData({ ...requestData,...response.data?.TaskList, ...response.data?.TaskList?.buildingId, ...response.data?.TaskList?.unitId, Worker: response.data?.TaskList?.workerId, worker_roles: response.data?.TaskList?.workerId?.PersonalDetails[0]?.worker_roles ,task_image:JSON.parse(response.data?.TaskList?.task_image).map((im) => ({ url: im }))})

            const imgUrlMake = JSON.parse(
              response.data?.TaskList?.task_image
            )?.map((im) => ({ url: im }));
            setSelectedImages(imgUrlMake);
          }
         
          

     

        })
        .catch((e) => {
          //   setLoading(false);
        });
    }
  }, [taskss_id]);

  const onClickImages = (url) => {
    setRequestData({...requestData,default_image:url});
  };

useEffect(() => {


  setIsEditable(requestData?.created_by !== userDetails?.id ? false: true)

  


},[userDetails,requestData])


const {
  setisKeyPress,
  Count,
  setsearchKey,
  searchKey,
  setRecord,
  record,
  setPages,
  pages,
  totallength,
  paginationLoading,
  handleNextbtn,
  handlePrevbtn,
  PageShowFunc,
  SearchListApi,
  allData,
  responseData,
  callAnyApi
} = useSearchListPagination();

useEffect(() => {
 
  callAnyApi(`/task/tasklogs/${taskss_id}`);
  

}, [searchKey, record, pages]);


  return (
    <DashboardLayouts>
      {allowLoading && <Loader />}
      <div className="breadcrumb row justify-content-between align-items-center">
        <div className="col-xl-6 d-flex align-items-center dashboard-upper-menu col-md-6 col-auto">
          <Link to={
            designation === "Owner" || designation === "Partner"
              ? "/dashboard"
              : `/${designation}dashboard`.toLowerCase()
          } className="d-flex align-items-center back-link">
            <BsArrowLeft className="me-2 back-arrow m-0 " color="black" />
            <i className="icon-dashboard"></i>
            <h3 className="mb-0 fw-normal">Dashboard</h3>
          </Link>
        </div>

        {(designation !== "Tenant" && designation !== "Worker") && <div className="col-auto manage-building-btn d-flex">
         
         {isEditableItem && <Link

            to={
              (designation == "Owner" || designation == "Partner") ? `/addtask/${taskss_id}` : `/${designation.toLowerCase()}/addtask/${taskss_id}`}

            className="btn btn-outline-primary me-2 d-flex align-items-center"
          >
            Edit <FaPen className="ms-3" />
          </Link>}

          <Link


            to={
              (designation == "Owner" || designation == "Partner") ? `/addtask` : `/${designation.toLowerCase()}/addtask`}

            className="btn btn-outline-primary me-2">
            Create Task
          </Link>
        </div>}
      </div>

      <section className="w-100 mt-2 task-details ag_task-details mb-5 ">
        <div className="row justify-content-between ">
          <div className="col-12 col-xl-6 left col-lg-auto col-sm-6">
            <h2 className="fw-bold heading-text mb-4">Assigned To</h2>
            <p>
              Worker Name : {Worker?.first_name} {Worker?.middle_name}{" "}
              {Worker?.last_name} (
              {worker_roles?.charAt(0)?.toUpperCase() +
                worker_roles?.slice(1)}
              )
            </p>
            <p>Building Name : {building_name}</p>
            <p>Unit Name : {unit_name}</p>
            <p>DeadLine: {moment(deadline).format("ll LT")}</p>
            <p>
              Description:
              {task_description ? (
                <p>
                  {task_description?.slice(0, 249)}
                  {task_description?.length > 250 && "..."}
                </p>
              ) : (
                "N/A"
              )}
            </p>
            <p >Priority: <span style={{ color: `${priority=="High"?"red": priority=="Normal"?"blue": "green"}` }}>{priority ? priority : "N/A"}</span> </p>
          </div>
        
         

              
        
          <GallaryBox   selectedImages={selectedImages}  defaultImg={defaultImg} handleDefaultImage={handleDefaultImage} onSelectFile={onSelectFile} deleteHandler={deleteHandler}/>
        
        </div>
      </section>

      <div>
        <hr className="w-100 mb-1" style={{ border: "1px solid #b6b6b6" }} />

        <div className="list-data">
          <h1 className="heading-text mb-4">Task Logs</h1>
          {/* --- Data filter --- */}
          <div className="data-filters d-flex justify-content-between align-items-center mb-4">
            <div className="page-records d-flex align-items-center">
              <form action="" className="number">
                <select
                  className="number-box"
                  value={record}
                  name="record"
                  onChange={(event) => {
                    setRecord(event.target.value);
                    setPages(1);
                  }}
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="15">15</option>
                </select>
              </form>
              <h3 className="mb-0 ms-2 d-none d-sm-block">Records Per Page</h3>
            </div>

          
          </div>
        </div>

        <div className="w-100 overflow-auto">
          <table className="dashboard-table w-100">
            <thead className="table-heading">
              <tr>
                <th>SL No</th>
                <th>Task</th>
                <th>Issued By</th>
                <th>Description</th>
                <th> Deadline</th>
                <th> Worker</th>
                <th> Priority</th>
                <th>Status</th>
             
              </tr>
            </thead>
           
              <tbody className="t-data">
                {allData.length > 0 ? (
                  allData.map((items, i) => (
                    <tr>
                      <td>
                        {pages > 1 ? record * (pages - 1) + i + 1 : i + 1}
                      </td>
                      <td>{items.task_title}</td>
                      <td>{`${items.createdBy?.first_name} ${items.createdBy?.last_name}`}</td>
                      <td>{items?.task_description.slice(0,160)} {items?.task_description?.length>160&& "..."}</td>
                      <td>  { moment( items.deadline).format("L")  }</td>
                      <td>{`${items.workerId?.first_name} ${items.workerId?.last_name}`}</td>
                      <td  style={{
                       color: `${items?.priority=="High"?"red": items?.priority=="Normal"?"blue": "green"}`
                     }}> {items.priority}</td>
                  
                   
<td style={{ color: items.receiver_status == "In Progress" ? "orange"  : items.receiver_status == "Pending" ? "red" : "green" }}>{items.receiver_status}</td>

                  
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
       
          </table>
        </div>
      </div>
      {Count > 5 && totallength.length > 1 ? (
          <div className="table_bottom d-flex align-items-center justify-content-end mt-5 pageNumbers">
            <button
              onClick={handlePrevbtn}
              disabled={pages == 1 ? true : false}
            >
              <GrFormPrevious className="pagebutton" color="#bebebe" />
            </button>
            <ul className="d-flex">{PageShowFunc}</ul>
            <button
              onClick={handleNextbtn}
              disabled={pages == PageShowFunc.length ? true : false}
            >
              <GrFormNext className="pagebutton" color="#bebebe" />
            </button>
          </div>
        ) : null}
    </DashboardLayouts>
  );
}
export default TaskDetails;
